export default {
    // BACKEND_URL: 'http://it.robooky.ru:8080/api'
    // BACKEND_URL: `${process.env.BACKEND_URL}/api`
    BACKEND_URL: `https://backend.it.robooky.ru/api`
};
